import moment from "moment";
import { log } from "../utils/logger";

export default function generateCampaigns({ SAMPLE_RECORD_COUNT = 100 } = {}) {
  log(`%c[+] Generating [${SAMPLE_RECORD_COUNT}] mock[DATASETS]`, "color:green");

  // Exported Array
  const SAMPLE_DATA = [];

  const SAMPLE_PERMISSIONS = [
    "U", // Private
    "G", // Group
    "C", // Company
  ];

  // Generator configs
  const SAMPLE_STATUSES = [
    0, // editing
    1, // processing
    2, // created
  ];

  function getSampleFromArray(array) {
    return array[Math.round(Math.random() * (array.length - 1))];
  }

  for (let i = 0; i < SAMPLE_RECORD_COUNT; i++) {
    const created_days_ago = Math.round(Math.random() * 90);
    const updated_days_ago = Math.round(created_days_ago / 2);
    const is_file_upload = Math.random() < 0.3 ? null : `sampleFile_${i}.csv`;

    const sample_record = {
      // Suggest adding the following meta-data to the API response
      email_count: Math.round(Math.random() * 200) + 100,
      sms_count: Math.round(Math.random() * 300) + 100,
      voice_count: Math.round(Math.random() * 50) + 100,
      tty_count: Math.round(Math.random() * 5) + 100,
      created_by: "Sample Data",

      // Actual Values
      dataset_id_bint: i,
      title_vch: `Sample ${i}`,
      condition_txt: ``,
      active_ti: Math.random() > 0.3 ? 1 : 0,
      created_by_bint: 1,
      created_dt: moment().subtract(created_days_ago, "d").toDate(),
      updated_dt: moment().subtract(updated_days_ago, "d").toDate(),
      permission_ch: getSampleFromArray(SAMPLE_PERMISSIONS),
      status_int: Math.round(Math.random() * (SAMPLE_STATUSES.length - 1)),
      file_vch: is_file_upload,
      col_mapping_vch: is_file_upload
        ? JSON.stringify({ csv_header: "Sample", csv_header2: "Mapping" })
        : null,
    };

    SAMPLE_DATA.push(sample_record);
  }

  return SAMPLE_DATA;
}
